var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-fields"},[_vm._t("default",null,{"fields":_vm.fields})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }